// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"d0b8b6ca","413":"4c79f581","963":"b2627b8f"}[chunkId] + ".chunk.js";
};